import i18n from '@/i18n/index.js';

const ERROR = {
  'test message': i18n.t('測試訊息'),
  NO_PVP_LOBBY: 'The lobby is not exist!',
  LOBBY_OWNER_DISCONNECTED: 'The lobby owner is disconnected!',
  GAME_IS_JUDGING: 'Game is judging!',
  OPPONENT_DISCONNECTED: 'Opponent is disconnected!',
  UNFINISHED_GAME: 'The user still has an unfinished game!',
  SELF_CREATED_LOBBY: 'Can not enter self-created lobby!',
  INCORRECT_ACTION: 'Incorrect action!',
  INCORRECT_USER: 'Incorrect user!',
  LOBBY_NOT_STARTED: 'The lobby has not started yet',
  VERIFICATION_NOT_OVER: 'There are Verification not over',
  SOME_USER_IS_NOT_READY: 'Some user is not ready!',
  THE_LOBBY_IS_FULL: 'The lobby is full!',
  HAS_UNFINISHED_GAME: 'The user still has an unfinished game!',
  NOT_IN_ANY_LOBBY: 'User is not in any lobbies!',
};

export default ERROR;
